import { DocumentPanel } from '../../components/panels/DocumentPanel';
import { GeologyReport } from '../../components/panels/GeologyReport';
import { ProgressChart } from '../../components/panels/ProgressChart';
import type { Dashboard as DashboardData } from '../../lib/types';
import { LatestDocPanel } from './LatestDocPanel';

/** The folder the DGOS reports are filed in. A constant, so the panel loads it once. */
const DGOS_FOLDER = /daily geological operations summary|\bdgos\b/i;

export function DashboardScreen({ data }: { data: DashboardData }) {
  return (
    <div className="panelgrid">
      <LatestDocPanel
        key={data.well.id}
        wellId={data.well.id}
        folder={DGOS_FOLDER}
        title="Daily Geological Operations Summary"
        fallback={<GeologyReport title={data.documents[0].title} />}
      />

      <DocumentPanel doc={data.documents[1]}>
        <ProgressChart title={data.well.name} kpis={data.kpis} />
      </DocumentPanel>
    </div>
  );
}
